import { cn } from "utils/helpers";
import type { LocalColumn } from "../schedule-of-rates.types";
import { COLUMN_TYPE_LABELS, SCHEDULE_CELL_BORDER, SCHEDULE_SAMPLE_LABELS } from "../schedule-utils";

export interface ScheduleOfRatesPreviewTableProps {
	columns: LocalColumn[];
}

const SAMPLE_ROW_COUNT = 4;

const ScheduleOfRatesPreviewTable: React.FC<ScheduleOfRatesPreviewTableProps> = ({
	columns,
}) => {
	if (columns.length === 0) {
		return (
			<div className="flex items-center justify-center rounded-lg border border-dashed border-gray-300 py-12">
				<p className="text-sm text-gray-400">
					Add columns to see a preview
				</p>
			</div>
		);
	}

	return (
		<div className="overflow-x-auto rounded-lg border border-[#EAECF0]">
			<table
				className="w-full table-auto"
				data-testid="schedule-preview-table"
			>
				<caption className="sr-only">
					Preview of schedule with current column configuration
				</caption>
				<thead>
					<tr className="bg-[#F9FAFB]">
						<th
							className={cn(
								SCHEDULE_CELL_BORDER,
								"w-10 px-2 py-2 text-center font-roboto text-xs font-medium text-tertiary-600"
							)}
						>
							#
						</th>
						{columns.map((col) => (
							<th
								key={col.localId}
								className={cn(
									SCHEDULE_CELL_BORDER,
									"px-2 py-2 font-roboto text-xs font-medium text-tertiary-600"
								)}
							>
								<div className="flex items-center gap-1">
									<span>{col.label}</span>
									<span className="text-[10px] text-gray-400">
										({COLUMN_TYPE_LABELS[col.columnType]})
									</span>
								</div>
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{Array.from({ length: SAMPLE_ROW_COUNT }, (_, rowIdx) => (
						<tr key={rowIdx}>
							<td
								className={cn(
									SCHEDULE_CELL_BORDER,
									"bg-gray-50 text-center font-roboto text-xs text-primary-500"
								)}
							>
								{rowIdx + 1}
							</td>
							{columns.map((col) => (
								<td
									key={col.localId}
									className={cn(
										SCHEDULE_CELL_BORDER,
										"px-2 py-2 font-roboto text-xs italic text-gray-400"
									)}
								>
									{SCHEDULE_SAMPLE_LABELS[col.columnType]}
								</td>
							))}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export { ScheduleOfRatesPreviewTable as SchedulePreviewTable };
